import { AuthFlowType, B2BOAuthProviders, B2BProducts } from "@stytch/vanilla-js";
import { StytchB2B, useStytchMemberSession } from "@stytch/react/b2b";
import { Navigate } from "react-router-dom";
import { Stack, Typography } from "@mui/joy";

// Use on the frontend (React components) to get domain
export const getDomainFromWindow = () => {
    if (typeof window !== "undefined") {
        return window.location.origin;
    }

    return null;
};

export default function Login() {
    const { session } = useStytchMemberSession();

    if (session) {
        return <Navigate to="/" />;
    }

    const domain = getDomainFromWindow();

    return (
        <Stack
            display="flex"
            alignItems="center"
            flexDirection="column"
            justifyContent="center"
            spacing={2}
            sx={{
                flex: "1 1 auto",
                position: "relative",
                overflowY: "auto",
                display: "flex",
            }}
        >
            <Typography level="body-sm">Please login to continue</Typography>
            <StytchB2B
                config={{
                    products: [B2BProducts.oauth],
                    authFlowType: AuthFlowType.Discovery,
                    oauthOptions: {
                        providers: [B2BOAuthProviders.Microsoft, B2BOAuthProviders.Google],
                        loginRedirectURL: domain + "/authenticate",
                        signupRedirectURL: domain + "/authenticate",
                        discoveryRedirectURL: domain + "/authenticate",
                    },
                    sessionOptions: {
                        sessionDurationMinutes: 30 * 24 * 60,
                    },
                }}
                callbacks={{
                    onEvent: ({ type, data }) => {
                        console.log("onEvent", type, data);
                    },
                    onError: (data) => {
                        console.log("onError", data);
                    },
                }}
            />
        </Stack>
    );
}
